export function urlEstadoManutencao(base = process.env.REACT_APP_API_BASE_URL || "") {
  return `${base.replace(/\/+$/, "")}/manutencao/status`;
}

export async function consultarEstadoManutencao({ signal, fetchImpl = fetch } = {}) {
  const resposta = await fetchImpl(urlEstadoManutencao(), {
    method: "GET", credentials: "omit", cache: "no-store", signal,
  });
  // Compatibilidade durante a primeira publicação: API antiga ainda sem o endpoint.
  if (resposta.status === 404 || resposta.status === 405) return { ativo: false, legado: true };
  if (!resposta.ok) throw new Error("Disponibilidade não confirmada");
  const estado = await resposta.json();
  if (typeof estado?.ativo !== "boolean") throw new Error("Estado de disponibilidade inválido");
  return { ativo: estado.ativo, legado: false };
}

export function lerManutencaoConfirmada(storage) {
  try { return storage?.getItem("sear:manutencao:v1") === "ativa"; }
  catch { return false; }
}

export function guardarManutencaoConfirmada(storage, ativo) {
  try {
    if (ativo) storage?.setItem("sear:manutencao:v1", "ativa");
    else storage?.removeItem("sear:manutencao:v1");
  } catch { /* O bloqueio do servidor independe do armazenamento do navegador. */ }
}
